// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1bufC","bar":"Loader_bar__2i7v7"};